<template>
  <div 
    class="popupWrap" 
    :class="{ 'active' : openOrClose }" 
    @click="dimmedClickHandler" 
  >
    <div class="contentWrap" ref="contentWrap">
      <h2>작업 이력</h2>

      <!-- <dl class="info">
        <dt>공정도명</dt>
        <dd>
          <p class="title">{{ popupTitle }}</p>
          <p class="desc">버전 : ver.2  수정일 : 2022.10.27 23:00:03</p>
        </dd>
        <dt><span class="txt">일자 설정</span></dt>
        <dd><button class="btnCalendar"><span>2022-10-27</span></button></dd>
      </dl>  -->

      <div class="scrlWrap">
        <table class="list">
          <colgroup>
            <col :style="{ width : '135px' }" /> 
            <col :style="{ width : '60px' }" /> 
            <col :style="{ width : '90px' }" /> 
            <col :style="{ width : '*' }" /> 
            <col :style="{ width : '80px' }" />
            <col :style="{ width : '106px' }" /> 
          </colgroup>
          <thead>
            <tr>
              <th>일시</th>
              <th>분류</th>
              <th>공개</th>
              <th>메모</th>
              <th>-</th>
              <th>등록자</th>
            </tr>
          </thead>
          <tbody>
            <!-- <ul>
              <li v-for="( list , idx ) in srchList">
                processId, id, userId, userName, memo, createdDate, attribute, attributeInfo
                {{ Object.keys( list ) }}
              </li>
            </ul> -->
            <tr v-if="srchList.length == 0">
              <td colspan="6" class="noneData">작업 이력이 없습니다.</td>
            </tr>

            <tr v-for="({ createdDate , userName , content, memo , processId , id, publicActive, thumbnail } , idx ) in srchList">
              <td>{{ formatDate(createdDate) }}</td>
              <td>{{ publicActive > 0 ? "공개" : "저장" }}</td>
              <td>{{ publishType[publicActive] }}</td>
              <td>
                <p class="title">
                  <span>{{ memo }}</span>
                </p>
              </td>
              <td>
                <button v-if="content !== null && thumbnail && processData.processType == 'NORMAL'" class="btnLoad" @click="viewImage(`data:image/jpeg;base64,${thumbnail}`)">미리보기</button>
<!--                <button v-if="content !== null" class="btnLoad" @click="loadHandler({ processId , id , userName , memo, publicActive, thumbnail } , $event )">불러오기</button>-->
              </td>
              <td>{{ userName }}</td>
            </tr>

            <!-- <tr>
              <td>2022.10.27 23:00:03</td>
              <td>
                <p class="title">
                  <span>공저자 공정도 수정사항 적욕(ver2)</span>
                  <button class="btnToggle">열고 닫기 토글 버튼</button>
                  <button class="btnLoad">불러오기</button>
                </p>
              </td>
              <td>공저자명B</td>
            </tr>
            <tr>
              <td colspan="3">
                <div class="detailInfoWrap">
                  <h3>수정사항 참고 (요필)</h3>
                  <p>장비명 XRD를 TEM으로 수정하였습니다.</p>
                </div>
              </td>
            </tr>-->
          </tbody>
        </table>
      </div>

      <close-btn :closeHandler="clickCloseHandler" />
    </div>

    <div v-show="imageUrl !== false" class="imgViewer" @click="imageUrl=false">
      <div class="overflow">
        <img :src="imageUrl" alt="" />
      </div>
    </div>    

  </div>
</template>

<script>
import CommNew from "@processEditor/CommNew";
import CloseBtn from '@components/btns/CloseBtn.vue'; 
import TextAlign from '@tiptap/extension-text-align';
export default {
  mixins:[CommNew],
  components : {
    CloseBtn , 
  } , 
  props : {
    crntObj : Object , 
  } , 
  data () {
    return {
      cautionBln : false , 
      str : '' , 
      imageUrl : false,
      srchList : [] , 
      processData : {},
      publishType : ["비공개","일반","위원,간사"]
    }
  } , 
  computed : {
    popupTitle () {
      const { processName } = this.PROCESS_INFO ; 
      return processName ; 
    } , 
    openOrClose ( bln ) {
      if ( this.crntObj.openBln ) {
      //   setTimeout(_=>{
      //     this.$refs.inputWrite.focus() ; 
      //   } , 100 ) ; 
        this.srchListHandler() ; 
      }
      return this.crntObj.openBln ; 
    } , 
  } , 
  mounted () {

  } , 
  methods : {
    viewImage(url){
      this.imageUrl = url;
    },    
    formatDate(inputDate) {
      var date = new Date(inputDate);
      var year = date.getFullYear().toString().substr(-2);
      var month = (date.getMonth() + 1).toString().padStart(2, '0');
      var day = date.getDate().toString().padStart(2, '0');
      var hours = date.getHours().toString().padStart(2, '0');
      var minutes = date.getMinutes().toString().padStart(2, '0');
      
      return year + '/' + month + '/' + day + ' ' + hours + ':' + minutes;
    },    
    async loadHandler ({ processId , id : processLogId , userName , memo, publicActive, thumbnail } , e ) {
      // TODO 불러오기 구현시 채번 관련하여 고려해야됨. $wApi.process.log.put에서 채번을 함께 진행중임. publicActive > 0 이면 채번됨.
      const me = await this.$wApi.user.me();
      // console.log({ processId , processLogId , userName , memo , me }) ; 

      const id = this.$route.query.processId ; 
      await this.$wApi.process.log.put({ 
        publicActive,
        thumbnail,
        memo : `${ me.companyName }의 ${ me.name }가 ${ userName }의 정보를 덮어쓰기함` 
      } , id ) ; 

      const loadRslt = await this.$wApi.process.log.overWrite({ processId , processLogId }) ; 
      if ( loadRslt ) { this.updateStatus({ logHistoryBln : true }) }

      this.clickCloseHandler( e ) ; 
    } , 
    async srchListHandler () {
      const id = this.$route.query.processId ; 
      this.srchList = await this.$wApi.process.log.get( null , id ) ; 
      this.srchList.sort(function(a, b) {
        return b.id - a.id;
      });
      this.processData = this.PROCESS_INFO;
      // console.log({ srchList : this.srchList }) ; 
    } , 
    dimmedClickHandler ( e ) {
      if ( !this.crntObj.openBln ) return ; 
      if ( !this.$refs.contentWrap.contains( e.target ) ) {
        // this.crntObj.closeHandler() ; 
        // this.clickCloseHandler( e ) ; 
      }
    } , 
    clickCloseHandler ( e ) {
      e.preventDefault() ; 
      e.stopPropagation() ; 

      this.cautionBln = false ; 
      this.crntObj.closeHandler() ; 
    } , 
  } , 
}
</script>

<style lang="scss" scoped>
  @import "@/style/popup.scss";
  .popupWrap {
    backdrop-filter: blur( 0px ) !important; 

    .imgViewer {
      display: flex; align-items: center; justify-content: center;
      position: fixed; top:0; left:0; right: 0; bottom: 0;
      background: rgba(0, 0, 0, .1);
      overflow: auto;
      z-index:101;
      cursor: pointer;
      .overflow {
        display: flex; align-items: center; justify-content: center;
        max-width: 80%; max-height: 80%;
        overflow: auto;
      }
      img {
        width: auto;
        height:auto;
        padding: 40px;
        background-color: #fff;
      }
    }
    .contentWrap {
      --cautionClr: #F64E4E; 
      width: 712px; 
      min-height: 217px; 
      height: fit-content; 
      max-height: 85%;
      background-color: #fff; 
      gap: var( --default-gap ); 

      > h2 {
        font-size: 20px; 
        justify-content: start; 
      }

      dl.info {
        margin-top: calc( var( --default-gap ) / 2 ); 
        --dt-width: 76px; 
        display: flex; 
        flex-wrap: wrap; 
        row-gap: var( --default-gap ); 

        dt , dd {
          display: flex; 
        }
        dt {
          @include text-prt-sb; 
          font-size: 16px; 
          color: $gray-6; 
          min-width: var( --dt-width ); 
          flex-shrink: 0; 

          .txt {
            height: 33px; 
            display: flex; 
            align-items: center; 
          }
        } // end of dt 
        dd {
          width: calc( 100% - var( --dt-width ) ); 
          flex-direction: column; 
          gap: 10px; 
          > * { line-height: 16.71px; }

          p.title {
            color: $gray-3; 
            font-size: 16px; 
          }
          p.desc {
            color: $gray-9; 
            font-size: 14px; 
          }

          .btnCalendar {
            border: 1px solid $gray-9; 
            width: 131px; 
            border-radius: 4px; 
            height: 33px; 
            font-size: 14px; 
            letter-spacing: -0.02em; 
            @include text-prt-m; 
            color: $gray-9; 
            display: flex; 
            justify-content: center; 
            align-items: center; 
            gap: 8px; 

            &::after {
              content: ''; 
              display: flex; 
              width: var( --default-gap ); 
              height: var( --default-gap ); 
              background: url('@/assets/icons/calendar_month.svg') right center no-repeat; 
            }

            // calendar_month
          }
        } // end of dd 

      } // end of dl.info 

      .scrlWrap {
        overflow: hidden; 
        overflow-y: auto; 
        margin-top: 8px; 
        @include scrlbar; 
      }

      table.list {
        width: 100%; 
        // margin-top: 8px; 
        border-collapse: separate; 
        border-spacing: 0; 

        th , td {
          height: 40px; 
          vertical-align: middle; 
          font-size: 14px; 
          color: $gray-3; 
        } 

        thead {
          th {
            border-bottom: 1px solid $gray-3; 
            @include text-prt-sb; 
            position: sticky; 
            top: 0px; 
            background-color: $white; 
          }
        }
        tbody {
          td {
            border-bottom: 1px solid $gray-d; 
            @include text-prt-m; 
            padding: 3px var( --default-gap ); 
            text-align: center; 

            &.noneData {
              height: 200px; 
              text-align: center; 
              vertical-align: middle; 
            }

            p.title {
              display: flex; 
              align-items: center; 
            }

            .btnToggle {
              font-size: 0; line-height: 0; 
              width: 24px; height: 24px; 
              background: url('@/assets/icons/expand_more-type2.svg') center center no-repeat; 
            }
            .btnLoad {
              width: 58px; height: 22px; 
              background-color: $gray-e; 
              color: $gray-6; 
              @include text-prt-m; 
              font-size: 12px; 
              margin-left: auto; 
            }
            .btnLoad+.btnLoad{margin-top:3px;}

            .detailInfoWrap {
              text-align: left; 
              padding-bottom: 16px; 
              > h3 {
                padding-top: 16px; 
                // padding-bottom: 8px; 
                padding-bottom: var( --default-half-gap ); 
                
                @include text-prt-sb; 
                color: $gray-3; 
                font-size: 16px; 
              }
              > p {
                border: 1px solid $gray-9; 
                @include text-prt-m; 
                color: $gray-3; 
                padding: 8px; 
                min-height: 80px; 
              }
            }
          }
        }
      } // end of table 
    } // end of .contentWrap

  } // end of .popupWrap

  .btnConfirm {
    @include btn-confirm; 
    align-self: center; 
  }
</style>

